/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconIdea = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-idea',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("path", { d: "M16.184 11.723a4.887 4.887 0 0 0 .907-2.848c0-2.762-2.279-5-5.09-5-2.813 0-5.092 2.238-5.092 5 0 1.063.334 2.043.907 2.848.147.207.322.441.51.691.512.691 1.125 1.52 1.582 2.336.414.742.625 1.516.728 2.246L8.699 17a4.426 4.426 0 0 0-.47-1.348c-.393-.703-.882-1.363-1.371-2.023a41.024 41.024 0 0 1-.613-.836A6.77 6.77 0 0 1 5 8.875C5 5.078 8.134 2 12 2s7 3.078 7 6.875a6.745 6.745 0 0 1-1.249 3.918c-.199.281-.405.559-.612.836-.49.656-.979 1.316-1.372 2.023a4.425 4.425 0 0 0-.47 1.348h-1.933c.104-.73.314-1.508.728-2.246.458-.816 1.07-1.645 1.583-2.336.187-.25.358-.484.505-.691l.004-.004ZM12 7c-1.054 0-1.909.84-1.909 1.875a.633.633 0 0 1-.636.625.633.633 0 0 1-.637-.625c0-1.727 1.424-3.125 3.182-3.125.35 0 .636.281.636.625A.633.633 0 0 1 12 7Zm0 15c-1.758 0-3.182-1.398-3.182-3.125v-.625h6.364v.625C15.182 20.602 13.758 22 12 22Z" })));
});
IconIdea.displayName = 'IconIdea';
export default IconIdea;
